import {
  Autocomplete,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Grid,
  IconButton,
  Input,
  MenuItem,
  Select,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TextField,
  TextareaAutosize,
  Tooltip,
  Typography,
} from "@mui/material";
import { useCallback, useEffect, useMemo, useState } from "react";
import { customDateFormat, parseAllocationDate } from "./utils";
import { useRefund, getTodaysDateInLocalTimezone } from "./hooks";
import SettingsTwoToneIcon from "@mui/icons-material/SettingsTwoTone";
import FileDownloadOutlinedIcon from "@mui/icons-material/FileDownloadOutlined";
import UpdateGenericWorkflowDialog from "../Workflow/UpdateGenericWorkflowDialog";
import { numberFormatter } from "../../utils/generalFunctions";
import { toast, ToastContainer } from "react-toastify";
import AttachFileIcon from "@mui/icons-material/AttachFile";
import InfoOutlineIcon from '@mui/icons-material/InfoOutlined';
import Badge from '@mui/material/Badge';
import instance  from "../../redux/api";
import {
  fetchFile,
} from "../../Services/api";
import { useRef } from "react";
import DownloadIcon from "@mui/icons-material/DownloadOutlined";
import { CircularProgress } from "@mui/material";
import { downloadFileModdules } from "../CashAllocation/constants";
import CommonMultiFileUpload from "../documents/CommonMultiFileUpload";

export const inputStyleObj = {
  border: "1px solid #ccc",
  padding: 4,
  paddingLeft: 16,
  fontSize: 13,
  width: "95%",
  borderRadius: 5,
};
export const selectStyleObj = {
  // border: "1px solid #ccc",
  padding: 4,
  borderWidth: 1,
  paddingLeft: 16,
  fontSize: 13,
  width: "95%",
  height: 38,
  borderRadius: 5
};

const History = ({ fixedDetails, history, transaction }) => {
  const [
    openUpdateGenericRefundWorkflowDialog,
    setOpenUpdateGenericRefundWorkflowDialog,
  ] = useState(false);
  const [currentWorkflowName, setCurrentWorkflowName] = useState("");
  const [currentTxnWorkflowDetails, setCurrentTxnWorkflowDetails] = useState(
    {}
  );
  const [downloadingFile, setDownloadingFile] = useState(null);
  const showToast = (type, message) => {
    toast[type](message, {
      position: toast.POSITION.TOP_RIGHT,
      autoClose: 5000,
    });
  };

  const handleUpdateGenericWorkflowDialog = () => {
    setOpenUpdateGenericRefundWorkflowDialog(false);
  };

  const handleDownloadClick = async (bucketKey, id) => {
    try {
      setDownloadingFile(id);
      const module = downloadFileModdules.activity;
      const url = `${fetchFile}?key=${bucketKey}&module=${module}&moduleName=Activity_Refund`;
  
      const response = await instance.get(url, { responseType: "blob" });
      const contentType = response.headers["content-type"];
      const blob = new Blob([response.data], { type: contentType });
      const fileURL = window.URL.createObjectURL(blob);
  
      const link = document.createElement("a");
      link.href = fileURL;
      link.download = bucketKey || "download";
      document.body.appendChild(link);
      link.click();

      document.body.removeChild(link);
      window.URL.revokeObjectURL(fileURL);

      showToast("success", "File downloaded successfully.");
    } catch (error) {
      showToast("error", "Failed to download the file.");
    } finally {
      setDownloadingFile(null);
    }
  }

  return (
    <div className="cash-allocation-dialogue-container">
      <Grid container>
        {fixedDetails.map(({ label, value }, i) => (
          <Grid
            item
            xs={12}
            md={6}
            key={label}
            paddingLeft={i % 2 ? 2 : 0}
            paddingRight={i % 2 ? 0 : 2}
            marginBottom={2}
          >
            <span style={{ fontWeight: label === "Policy#" ? 800 : 400 }}>
              {label}
            </span>
            <span style={{ fontWeight: "bold" }}>: {value}</span>
          </Grid>
        ))}
      </Grid>
      <TableContainer sx={{ height: 275, overflow: "auto" }}>
        <Table stickyHeader>
          <TableHead className="table-head" sx={{ "& th": { position: "sticky", top: 0, zIndex: 1, backgroundColor: "#fff" } }}>
            <TableRow>
              <TableCell
                className="table-cell"
                sx={{ fontSize: "15px", fontWeight: 800 }}
              >
                Requested On
              </TableCell>
              <TableCell
                className="table-cell"
                sx={{ fontSize: "15px", fontWeight: 800 }}
              >
                Reason
              </TableCell>
              <TableCell
                className="table-cell"
                sx={{ fontSize: "15px", fontWeight: 800 }}
              >
                Amt
              </TableCell>
              <TableCell
                className="table-cell"
                sx={{ fontSize: "15px", fontWeight: 800 }}
              >
                Ccy
              </TableCell>
              <TableCell
                className="table-cell"
                sx={{ fontSize: "15px", fontWeight: 800 }}
              >
                WF Status
              </TableCell>
              <TableCell
                className="table-cell"
                sx={{ fontSize: "15px", fontWeight: 800 }}
              >
                Files
              </TableCell>
              <TableCell
                className="table-cell"
                sx={{ fontSize: "15px", fontWeight: 800 }}
              >
                Action
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody className="table-body">
            {history.map((row, index) => (
              <TableRow key={index} className="table-row">
                <TableCell className="table-cell">
                  {customDateFormat(row?.request_date)}
                </TableCell>
                <TableCell className="table-cell">
                  {row?.refund_reason}
                </TableCell>
                <TableCell className="table-cell">{numberFormatter(row?.net_amt ?? row?.refund_amt ?? 0)}</TableCell>
                <TableCell className="table-cell">{row?.currency ?? transaction?.bank_details?.currency}</TableCell>
                <TableCell className="table-cell">
                  {row?.workflow?.workflow_status}
                </TableCell>
                <TableCell className="table-cell">
                  {row?.file ? (
                    row?.file.split(',').map((file, index) => (
                      <div
                        key={`${file}-${index}`}
                        style={{
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "flex-start",
                          marginTop: "10px",
                        }}
                      >
                        {downloadingFile === index ? (
                          <CircularProgress
                            style={{ color: "rgb(255, 90, 1)" }}
                            size={22}
                          />
                        ) : (
                          <IconButton
                            size="small"
                            onClick={() => handleDownloadClick(file, index)}
                            sx={{ color: "blue", p: 0, mr: "5px" }}
                            aria-label="download file"
                          >
                            <DownloadIcon />
                          </IconButton>
                        )}
                        <a
                          href={file}
                          rel="noopener noreferrer"
                          style={{
                            color: "blue",
                            textDecoration: "none",
                            cursor: "pointer",
                          }}
                          onClick={(e) => {
                            e.preventDefault();
                            handleDownloadClick(file, index);
                          }}
                        >
                          {file}
                        </a>
                      </div>
                    ))
                  ) : (
                    <span style={{ color: "#999", fontStyle: "italic" }}>
                      No file attached
                    </span>
                  )}
                </TableCell>
                <TableCell className="table-cell">
                  <IconButton>
                    <SettingsTwoToneIcon
                      onClick={() => {
                        setCurrentWorkflowName(
                          row?.workflow?.workflow_json_data?.workflow_name ?? ""
                        );
                        setCurrentTxnWorkflowDetails(row?.workflow ?? {});
                        setOpenUpdateGenericRefundWorkflowDialog(true);
                      }}
                      sx={{ fontSize: "25px", color: "#3b3f44" }}
                    />
                  </IconButton>
                  <IconButton>
                    <FileDownloadOutlinedIcon
                      sx={{ fontSize: "25px", color: "blue" }}
                    />
                  </IconButton>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>

      {openUpdateGenericRefundWorkflowDialog && (
        <UpdateGenericWorkflowDialog
          openUpdateGenericWorkflowDialog={
            openUpdateGenericRefundWorkflowDialog
          }
          handleUpdateGenericWorkflowDialog={handleUpdateGenericWorkflowDialog}
          workflowName={currentWorkflowName}
          currentWorkflowDetails={currentTxnWorkflowDetails}
        />
      )}
    </div>
  );
};

const Refund = ({ allocation, handleClose, currencies, transaction, isAuthorizedUser, isBankActivity, ROEList, UpdateROEList, viaHistoryLink = false }) => {
  const { history, formData, setFormData, submit, isApiInProgress, loadHistory } = useRefund(allocation, isBankActivity);
  const [isDialogOpen, setIsDialogOpen] = useState(true);
  const [showHistory, setShowHistory] = useState(true);
  const [brokerData, setBrokerData] = useState({});
  const [selectedBrokerName, setSelectedBrokerName] = useState("");
  const [isHovered, setIsHovered] = useState(false);

  const fixedDetails = useMemo(
    () => [
      {
        label: "Txn #",
        value: transaction?.Bank_Transaction_Id,
      },
      {
        label: "A/C #",
        value: transaction?.bank_details?.account_number,
      },
      {
        label: "A/C Name",
        value: transaction?.bank_details?.bank_name,
      },
      {
        label: "Txn Date",
        value: customDateFormat(allocation?.bank_txn?.Payment_Receive_Date),
      },
      {
        label: "Entity",
        value: transaction?.bank_details?.entity_name,
      },
      {
        label: "A/C Type",
        value: transaction?.bank_details?.account_type,
      },
      {
        label: "CCY",
        value: transaction?.bank_details?.currency,
      },
      // {
      //   label: "Cash Ref#",
      //   value: allocation?.cash_reference,
      // },
      // {
      //   label: "System",
      //   value: allocation?.allocation_systemid,
      // },
      // {
      //   label: "Bank A/c#",
      //   value: allocation?.bank_txn?.bank_details?.account_number,
      // },
      // {
      //   label: "Status",
      //   value: allocation?.allocation_status,
      // },
      {
        label: "Amount",
        value: numberFormatter(transaction?.Receivable_Amount ?? 0),
      },
      {
        label: "Bank Charges",
        value: numberFormatter(transaction?.Bank_Charges ?? 0),
      },
    ],
    [allocation]
  );

  const beneficiaryDetails = useMemo(() => {
    const baseDetails = [
      {
        label: "Payee A/C #",
        value: brokerData?.bank_acc_number ?? "-",
      },
      {
        label: "Sort Code",
        value: brokerData?.sort_code ?? "-",
      },
      {
        label: "Swift Code",
        value: brokerData?.swift_number ?? "-",
      },
      {
        label: "iban #",
        value: brokerData?.iban_number ?? "-",
      },
      {
        label: "Payee Name",
        value: brokerData?.payee_name ?? "-",
      },
    ];
  
    if (!isBankActivity) {
      baseDetails.push({
        label: "Remittance Details",
        value: allocation?.policy_fk?.Insured ?? "-",
      });
    }
  
    return baseDetails;
  }, [brokerData, allocation, isBankActivity]);
  
  const [selectedFile, setSelectedFile] = useState(null);
  const fileInputRef = useRef(null);

  const handleAttachClick = () => {
    fileInputRef.current.click();
  };

  const handleFileChange = (event) => {
    console.log("event.target.files", event.target.files)
    const file = event.target.files && event.target.files[0];
    if (file) {
      setSelectedFile(file);
      setFormData((prev) => ({
        ...prev,
        file: file,
      }));
    }
  };

  useEffect(() => {
    setShowHistory((!!history.length) || !isAuthorizedUser || viaHistoryLink);
  }, [history?.length]);

  const handleCloseDialog = useCallback(() => {
    setIsDialogOpen(false);
    handleClose("");
  }, [setIsDialogOpen]);

  // moved below after uploadedFiles state declaration to avoid TDZ

  const [ROEValue, setROEValue] = useState(1);

  const handleInputChange = useCallback(
    async (e) => {
      setFormData((data) => ({
        ...data,
        [e.target.name]: e.target.value,
      }));
      if (e.target.name == "beneficiary_name") {
        setSelectedBrokerName(e.target.value);
      }
      if (e.target.name == "roe") {
        setROEValue(e.target.value.split("-").pop().trim());
      }
    },
    [setFormData]
  );

  useEffect(() => {
    const fetchBrokerDetails = async () => {
      if (selectedBrokerName) {
        try {
          const response = await instance.post("documents/get_broker_by_broker_name/", {
            Broker_Name: selectedBrokerName
          });
          setBrokerData(response?.data);
        } catch (err) {
          console.error("Error fetching broker details", err);
          setBrokerData({});
        }
      }
    };
    fetchBrokerDetails();
  }, [selectedBrokerName]);  

  const handleAddShowHistory = () => {
    if (!isAuthorizedUser && showHistory) {
      toast.error("You are not assigned user!! Please re-assign and then try.", {
        position: toast.POSITION.TOP_RIGHT,
        autoClose: 1000,
      });
      return;
    }
    else {
      // When moving from History to Add (form), reset form state and files
      if (showHistory) {
        setFormData({
          aprover_name: allocation?.aprover_name || "",
          request_date: getTodaysDateInLocalTimezone(),
          refund_reason: "",
          refund_amt: "",
          roe: "",
          refund_type: null,
          comments: "",
          beneficiary_name: "",
          correspondence_bank_details: "",
          net_amt: 0,
          type: "ca",
        });
        setUploadedFiles([]);
        setBrokerData({});
        setSelectedBrokerName("");
        setROEValue(1);
        setSelectedFile(null);
        if (fileInputRef?.current) {
          fileInputRef.current.value = null;
        }
      }
      setShowHistory(!showHistory);
    }
  }

  useEffect(() => {
    if (
      isBankActivity &&
      transaction?.Receivable_Amount != null &&
      (formData.refund_amt === undefined || formData.refund_amt === "")
    ) {
      setFormData((prev) => ({
        ...prev,
        refund_amt: numberFormatter(transaction.Receivable_Amount ?? 0),
      }));
    }
    // Only set once, or add dependencies as needed
  }, [isBankActivity, transaction?.Receivable_Amount]);

  useEffect(() => {
    if (
      isBankActivity &&
      (formData.refund_type === undefined || formData.refund_type === null)
    ) {
      setFormData((prev) => ({
        ...prev,
        refund_type: { label: "Refund" },
      }));
    }
  }, [isBankActivity, formData.refund_type]);

  const refundTypes = [
    { label: "Refund" },
    { label: "Returned Premium" },
    { label: "Profit Commision" },
    { label: "No Claim Bonus" },
    { label: "Broker Commision" },
    { label: "Rebates" },
    { label: "Fees" },
  ];

  const bankRefundTypes = [
    { label: "Refund" }
  ];

  const refundAmtNumber = Number(formData.refund_amt);
  const receivableAmount = Number(transaction?.Receivable_Amount ?? 0);
  const isRefundAmtInvalid =
    !isBankActivity &&
    formData.refund_amt !== "" &&
    !isNaN(refundAmtNumber) &&
    refundAmtNumber > receivableAmount;

  // File Upload
  const [isFileUploadDialogOpen, setIsFileUploadDialogOpen] = useState(false);
  const [uploadedFiles, setUploadedFiles] = useState([]);
  const handleFileUploadDialog = () => {
    // fileInputRef.current.click();
    setIsFileUploadDialogOpen(true);
  };

  const handleSubmitAssing = useCallback(
    async (e) => {
      e.preventDefault();
      const submitResponse = await submit(uploadedFiles);
      if (submitResponse && ("shouldShowHistory" in submitResponse) && submitResponse.shouldShowHistory) {
        setShowHistory(true);
        setFormData({
          aprover_name: allocation?.aprover_name || "",
          request_date: getTodaysDateInLocalTimezone()
        });
        loadHistory();
      }
    },
    [setIsDialogOpen, submit, uploadedFiles]
  );

  // broker value
  const [brokerList, setBrokerList] = useState([]);
  const getBrokerList = async () => {
    const response = await instance.get("documents/get_broker_list/");
    setBrokerList(response?.data?.Broker_Name);
  }

  useEffect(() => {
    getBrokerList()
    if (isBankActivity) {
      setFormData((data) => ({
        ...data,
        ["type"]: "bank",
      }));
    } else {
      setFormData((data) => ({
        ...data,
        ["type"]: "ca",
      }));
    }
  }, [])

  // Net payment calculation
  useEffect(() => {
    const refundAmt = isBankActivity
      ? Number(transaction?.Receivable_Amount ?? 0)
      : Number(formData?.refund_amt ?? 0);
  
    const bankCharges = Number(transaction?.Bank_Charges ?? 0);
    const roe = Number(ROEValue ?? 1); // assuming ROEValue is defined and numeric
  
    const netPayment = refundAmt * roe - bankCharges;
  
    if (!isNaN(netPayment)) {
      setFormData((prev) => ({
        ...prev,
        net_amt: netPayment,
      }));
    }
  }, [formData?.refund_amt, ROEValue, transaction?.Receivable_Amount, transaction?.Bank_Charges, isBankActivity]);

  return (
    <Dialog
      open={isDialogOpen}
      onClose={(event, reason) => {
        if (reason === 'backdropClick') {
          return;
        }
        handleCloseDialog();
      }}
      fullWidth
      maxWidth={false} // disables the default maxWidth
      PaperProps={{
        sx: { width: "75%", maxWidth: "95%" }
      }}
    >
      <ToastContainer />
      <form onSubmit={handleSubmitAssing}>
        <DialogTitle
          style={{
            background: "#FCFCFC",
            // display: "flex",
            // justifyContent: "space-between",
            // alignItems: "center",
            // gap: "20%",
          }}
        >
          <Typography sx={{ fontSize: 20, textDecoration: "underline", fontWeight: 750, textAlign: "center" }}>Payment Request Form</Typography>
          {/* {isBankActivity && <Typography
            sx={{ fontSize: 15, fontWeight: 750, marginLeft: "30px" }}
          >
            Policy#: {allocation?.policy_id}
          </Typography>} */}
        </DialogTitle>
        <DialogContent sx={{ paddingBottom: "0px !important" }}>
          {showHistory ? (
            <History
              setShowHistory={setShowHistory}
              fixedDetails={fixedDetails}
              history={history}
              transaction={transaction}
            />
          ) : (
            <>
              <div style={{ 
                position: "absolute", 
                top: "10px", 
                right: "10px", 
                zIndex: 1000 
              }}>
                <div className="FileUploadIcon">
                  <div
                    style={{ display: "flex", flexDirection: "column" }}
                    onClick={handleFileUploadDialog}
                  >
                    <span
                      style={{ display: "flex", justifyContent: "center", fontSize: "14px" }}
                    >
                      Files: 
                      <Badge 
                        badgeContent={uploadedFiles.length} 
                        color="primary"
                        size="small"
                        anchorOrigin={{
                          vertical: 'bottom',
                          horizontal: 'right',
                        }}
                        style={{ marginLeft: "5px" }}
                      >
                        <AttachFileIcon style={{ fontSize: 15, paddingTop: "3px", cursor: "pointer" }} />
                      </Badge>
                    </span>
                  </div>

                  <CommonMultiFileUpload
                    isFileUploadDialogOpen={isFileUploadDialogOpen}
                    uploadedFiles={uploadedFiles}
                    setUploadedFiles={setUploadedFiles}
                    setIsFileUploadDialogOpen={setIsFileUploadDialogOpen}
                  />
                </div>
              </div>
              <Grid container fontSize={13}>
                {fixedDetails.map(({ label, value }, i) => (
                  <Grid
                    item
                    xs={12}
                    md={4}
                    key={label}
                    marginBottom={1}
                  >
                    <span className="ca_title">{label} </span>
                    <span className="ca_value" style={{ fontWeight: "bold" }}>: {value}</span>
                  </Grid>
                ))}
              </Grid>

              <Grid container>
                <Grid item xs={12} md={4}>
                  <p style={{ fontSize: 13, color: "#17191B", marginBottom: 0 }}>
                    Wire #
                  </p>

                  <Input
                    style={{ ...inputStyleObj }}
                    placeholder="Write details here"
                    name="refund_reason"
                    value={isBankActivity ? transaction?.Bank_Transaction_Id : `${transaction?.Bank_Transaction_Id} ${allocation?.policy_id}`}
                    onChange={handleInputChange}
                    required
                    disabled
                  />
                </Grid>

                <Grid item xs={12} md={4}>
                  <p style={{ fontSize: 13, color: "#17191B", marginBottom: 0 }}>FX</p>

                  <Select
                    style={{ ...selectStyleObj }}
                    name="roe"
                    onChange={handleInputChange}
                    value={formData.roe}
                    placeholder="Write details here"
                    required
                  >
                    {ROEList?.map((opt) => (
                      <MenuItem value={`${opt[0]}-${opt[2]}`}>
                        {opt[1]} - {opt[2]}
                      </MenuItem>
                    ))}
                  </Select>
                </Grid>

                <Grid item xs={12} md={4}>
                  <p style={{ fontSize: 13, color: "#17191B", marginBottom: 0 }}>Payment Type</p>
                  <Autocomplete
                    name="refund_type"
                    size="small"
                    autoHighlight
                    options={isBankActivity ? bankRefundTypes : refundTypes}
                    value={formData.refund_type || null}
                    onChange={(_, newValue) => {
                      setFormData((data) => ({
                        ...data,
                        refund_type: newValue,
                      }));
                    }}
                    renderInput={(params) => (
                      <TextField
                        placeholder={"Select Payment Type"}
                        {...params}
                        inputProps={{
                          ...params.inputProps,
                        }}
                      />
                    )}
                    disabled={isBankActivity}
                  />
                </Grid>

                <Grid item xs={12} md={4} >
                  <p style={{ fontSize: 13, color: "#17191B", marginBottom: 0 }}>
                    Refund Reason
                  </p>

                  <Input
                    style={{ ...inputStyleObj }}
                    placeholder="Write details here"
                    name="refund_reason"
                    value={formData.refund_reason}
                    onChange={handleInputChange}
                    required
                  />
                </Grid>

                <Grid item xs={12} md={4}>
                  <p style={{ fontSize: 13, color: "#17191B", marginBottom: 0 }}>
                    Amount
                  </p>

                  <Input
                    style={{ ...inputStyleObj }}
                    placeholder="Enter amount here"
                    name="refund_amt"
                    value={formData.refund_amt}
                    onChange={(e) => {
                      if (isNaN(e.target.value)) {
                        e.preventDefault();
                        e.stopPropagation();
                        e.target.value = formData.refund_amt || "";
                        return;
                      }
                      handleInputChange(e);
                    }}
                    required
                    disabled={isBankActivity}
                    error={isRefundAmtInvalid}
                  />
                  {isRefundAmtInvalid && (
                    <div style={{ color: "red", fontSize: 12, marginTop: 4 }}>
                      Amount should be less than bank rec amt
                    </div>
                  )}
                </Grid>

                {/* <Grid item xs={12} md={6} paddingRight={2}>
                  <p style={{ fontSize: 13, color: "#17191B" }}>Currency</p>

                  <Select
                    style={{ ...selectStyleObj }}
                    name="currency"
                    onChange={handleInputChange}
                    value={formData?.currency ?? allocation?.payment_currency}
                    placeholder="Write details here"
                    required
                  >
                    {currencies.map((opt) => (
                      <MenuItem value={opt.currency_code}>
                        {opt.currency_code}
                      </MenuItem>
                    ))}
                  </Select>
                </Grid> */}

                <Grid item xs={12} md={4} paddingTop={3}>
                  <div style={{ display: 'flex', alignItems: 'center', gap: "5px", padding: "15px 0" }}>

                    <p style={{ fontSize: 13, color: "#17191B", margin: "0" }}>Net Payment </p>
                    <span style={{ fontWeight: "bold", fontSize: "13px" }}>: {numberFormatter(formData?.net_amt ?? 0)}</span>

                    <Tooltip title="(ROE * Rec Amt) - Bank Charges">
                      <InfoOutlineIcon />
                    </Tooltip>
                  </div>
                </Grid>

                <Grid item xs={12} md={12} paddingRight={2}>
                  <div>
                    <p style={{ fontSize: 13, color: "#17191B", marginBottom: 0, marginTop:'0' }}>Comments</p>

                    <TextareaAutosize
                      style={{
                        height: 30,
                        width: "100%",
                        borderWidth: "1px",
                        borderRadius: "5px",
                        padding: "10px"
                      }}
                      name="comments"
                      value={formData.comments}
                      onChange={handleInputChange}
                      placeholder="Write details here"
                    />
                  </div>

                </Grid>
              </Grid>

              <Typography sx={{ fontSize: 20, textDecoration: "underline", fontWeight: 750, textAlign: "center" }}>Beneficiary Bank Details</Typography>
              <Grid container>

                <Grid item xs={12} md={6}>
                  <div>
                    <p style={{ fontSize: 13, color: "#17191B", marginBottom: 0 }}>Beneficiary Name</p>
                    <Select
                      style={{ ...selectStyleObj }}
                      name="beneficiary_name"
                      onChange={handleInputChange}
                      value={formData?.beneficiary_name}
                      placeholder="Write details here"
                      required
                    >
                      {brokerList?.map((opt) => (
                        <MenuItem value={opt}>
                          {opt}
                        </MenuItem>
                      ))}
                    </Select>
                  </div>
                  <div>
                    <p style={{ fontSize: 13, color: "#17191B", marginBottom: 0, width:'fit-content' }}>Correspondence Bank Details</p>
                    <TextareaAutosize
                      style={{
                        height: 30,
                        width: "90%",
                        borderWidth: "1px",
                        borderRadius: "5px",
                        padding: "10px",
                      }}
                      name="correspondence_bank_details"
                      value={formData.correspondence_bank_details}
                      onChange={handleInputChange}
                      placeholder="Write details here"
                    />
                  </div>
                </Grid>
                <Grid
                  item
                  xs={12}
                  md={6}
                  key={"1"}
                  style={{ marginTop: "25px" }}
                // paddingLeft={i % 2 ? 2 : 0}
                // paddingRight={i % 2 ? 0 : 2}
                >
                  {beneficiaryDetails.map(({ label, value }, i) => (
                    <div>
                      <span className="ca_title">{label} </span>
                      <span className="ca_value" style={{ fontWeight: "bold" }}>: {value}</span>
                    </div>
                  ))}
                </Grid>
              </Grid>
            </>
          )}
        </DialogContent>
        <DialogActions style={{ justifyContent: "flex-end", paddingRight: "2%" }}>
          { !viaHistoryLink &&
          <Button
            // onClick={() => setShowHistory(!showHistory)}
            onClick={() => handleAddShowHistory()}
            color="inherit"
            variant="outlined"
            sx={{ borderRadius: 100 }}
          >
            History
          </Button>}
          {showHistory && history && history.length > 0 && !isBankActivity && <Button
            onClick={() => handleAddShowHistory()}
            color="warning"
            variant="contained"
            sx={{ borderRadius: 100 }}
          >
            Add
          </Button>}
          <Button
            onClick={handleCloseDialog}
            color="inherit"
            variant="outlined"
            sx={{ borderRadius: 100 }}
          >
            Close
          </Button>
          {!showHistory && (
            <Button
              variant="contained"
              color="warning"
              sx={{ borderRadius: 100 }}
              type="submit"
              disabled={isApiInProgress}
            >
              Submit
            </Button>
          )}
        </DialogActions>
      </form>
    </Dialog >
  );
};

export default Refund;
